/**
 * El %IVA que se puede elegir depende de si la moto es eléctrica (pedido del 2026-10-21).
 *
 *   Combustión: 19 % (IVA) o 27 % (IVA + impuesto al consumo), como siempre.
 *   Eléctricas: sin IVA, 5 % o 19 %.
 *
 * Se decide por la MARCA, comparada sin tildes, mayúsculas ni espacios de más. Ojo: «BENELLI» (motos de
 * combustión) no es «BENELLI BIKES» (eléctricas): la comparación es por el nombre completo, no por prefijo.
 */

export const MARCAS_ELECTRICAS = ['STARKER', 'SUPER SOCO', 'MINCA', 'BENELLI BIKES', 'SEGWAY', 'VELOCIFERO']

export const OPCIONES_IVA = {
  combustion: [
    { value: '0.19', label: '19% (IVA)' },
    { value: '0.27', label: '27% (IVA + impo. consumo)' },
  ],
  electrica: [
    { value: '0', label: 'Sin IVA (0%)' },
    { value: '0.05', label: '5% (IVA eléctricas)' },
    { value: '0.19', label: '19% (IVA)' },
  ],
}

export const normalizarMarca = (m) => String(m || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toUpperCase()
  .replace(/\s+/g, ' ')
  .trim()

const ELECTRICAS = new Set(MARCAS_ELECTRICAS.map(normalizarMarca))

export const esElectrica = (marca) => ELECTRICAS.has(normalizarMarca(marca))

/**
 * El tipo de las motos elegidas: 'electrica', 'combustion', 'mixta' (hay de las dos: un mismo IVA no
 * vale para todas) o null si no hay ninguna.
 */
export const tipoIvaDe = (motos = []) => {
  if (!motos || !motos.length) return null
  const n = motos.filter((g) => esElectrica(g && g.marca)).length
  if (n === 0) return 'combustion'
  if (n === motos.length) return 'electrica'
  return 'mixta'
}

/** Las opciones del selector. Con una mezcla se muestran todas, pero no se deja registrar. */
export const opcionesIvaDe = (tipo) => {
  if (tipo === 'electrica') return OPCIONES_IVA.electrica
  if (tipo === 'mixta') {
    const vistas = new Set()
    return [...OPCIONES_IVA.electrica, ...OPCIONES_IVA.combustion]
      .filter((o) => (vistas.has(o.value) ? false : vistas.add(o.value)))
  }
  return OPCIONES_IVA.combustion
}

/** El IVA guardado en el formato del selector ('0.27', '0.05', '0'), o '' si no hay. Un 0 es SIN IVA. */
export const ivaComoOpcion = (v) => {
  if (v === null || v === undefined || v === '') return ''
  const n = Number(v)
  return Number.isFinite(n) ? String(n) : ''
}

/** ¿Ese IVA es una opción válida para ese tipo de moto? */
export const ivaValidoPara = (tipo, iva) => opcionesIvaDe(tipo).some((o) => o.value === ivaComoOpcion(iva))
